import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.667",
      d: "M14.167 11.667V17.5m-8.334-5.833V17.5m8.334-15V5M5.833 2.5V5m2.5 6.667L1.917 5.25m9.75-.25 6.416 6.417M6.667 5l6.666 6.667M2.5 5h15c.46 0 .833.373.833.833v5c0 .46-.373.834-.833.834h-15a.833.833 0 0 1-.833-.834v-5c0-.46.373-.833.833-.833"
    }, null, -1)
  ])))
}
export default { render: render }